<template>
  <el-checkbox-group
    v-model="checkList"
    :class="{'check-column':!isColumn}"
    @change="changeValue"
  >
    <template
      v-for="(item, index) in list">
      <el-checkbox
        v-if="!notShowList.includes(item)"
        :key="index"
        :disabled="disabled"
        :class="{ 'border-block': borderBlock, 'block': block }"
        :label="item[valueKey]"
        @change="handleCick(item.id)">
        <slot :item="item">
          <span>{{ item[labelKey] }}</span>
        </slot>
        <slot
          :id="item[valueKey]"
          name="input"
          :index="index"></slot>
        <slot
          :extra="item"
          name="extra">
        </slot>
      </el-checkbox>
    </template>
  </el-checkbox-group>
</template>
<script>
export default {
  name: 'VCheckboxGroup',
  props: {
    value: {
      type: Array,
      default:() => ([])
    },
    list: {
      type: Array,
      default: () => ([])
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    borderBlock: {
      type: Boolean,
      default: false
    },
    isColumn: {
      type: Boolean,
      default: true
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type:{
      type:[String,Number],
      default:''
    },
    notShowList:{
      type: Array,
      default: () => []
    },
    hasGroup:{
      type: Boolean,
      default: false
    },
    hasIcon:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkList: this.value||[]
    }
  },
  computed:{
    group_name(){
      let obj  = this.list.reduce((result, item)=>{
        if(item.is_group==1){
          result[item.group_name] = []
        }
        return result
      },{})
      return obj
    },
    group(){
      let obj = this.group_name
      this.list.some((item)=>{
        if(item.is_group==1){
          obj[item.group_name].push(item.id)
        }
      })
      return obj
    }
  },
  watch: {
    checkList: {
      // immediate: true,
      deep: true,
      handler(val) {
        if(this.hasGroup){
          // 判斷有多少個是衝突的
          let group = this.group
          Object.keys(group).some(key=>{
            let arr = group[key]
            const filterList = val.filter(item => arr.includes(item))
            if(filterList.length > 1) {
              let flag = false
              const result = val.reduce((result, item) => {
                if(arr.includes(item) && !flag) {
                  flag = true
                  return result
                }
                result.push(item)
                return result
              }, [])
              val = JSON.parse(JSON.stringify(result))
            }
          })
          this.$emit('input', val)
        }else{
          if(val.join() !== this.value.join()) {
            this.$emit('input', val)
          }
        }
      }
    },
    value: {
      deep: true,
      handler(val) {
        if(val.join() !== this.checkList.join()) {
          this.checkList = val
        }
      }
    }
  },
  methods: {
    changeValue(val) {
      this.$emit('change',this.type)
    },
    handleCick(id){
      this.$emit('check',id)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-checkbox-group {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  /*flex-direction: column;*/
  &.check-column{
    flex-direction: column;
  }
  .block {
    width: 100%;
  }
  .border-block {
    align-items: center;
    .el-checkbox__label {
      & > span {
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 30px;
        color: #409eff;
        font-size: 12px;
        border: 1px solid #d9ecff;
        border-radius: 4px;
        background: #ecf5ff;
      }
    }
  }
  .el-checkbox {
    position: relative;
    display: flex;
    // align-items: center;
    margin-right: 15px;
    margin-bottom: 5px;
    & /deep/ .el-checkbox__input {
      padding-top: 2px;
    }
  }
}
</style>
